import { CanvasHandler } from "../../handlers";
import { FabricObject } from "../../types/FabricCustomType";
import { IObjectPreview } from "../../types/HandlerObjectType";
import { TooltipSeatPreview } from "../../components/tooltip/TooltipSeatPreview";

class Seat implements IObjectPreview {
  private canvasHandler: CanvasHandler;
  private targetSeat!: FabricObject<Object> | null;

  constructor(canvasHandler: CanvasHandler) {
    this.canvasHandler = canvasHandler;
  }

  public activateObjectHover(event: any, seat: FabricObject<Object>): any {
    if (this.targetSeat != seat) {
      this.deactivateObjectHover();
      const seatCircle = seat.item(0);
      const htmlElement = TooltipSeatPreview(seat);
      this.canvasHandler.tooltipHandler.show(event.e, htmlElement);
      seatCircle.set({
        fill: `${seatCircle.stroke}90`,
        radius: seatCircle.radius + 0.5,
      });
      this.targetSeat = seat;
      this.canvasHandler.canvas.requestRenderAll();
    }

    if (this.targetSeat)
      this.canvasHandler.canvas.setCursor("pointer");
    else
      this.canvasHandler.canvas.setCursor("default");
  }

  public deactivateObjectHover = () => {
    if (this.targetSeat) {
      this.canvasHandler.tooltipHandler.hide();
      this.canvasHandler.canvas.setCursor("default");
      const seatCircle = this.targetSeat.item(0);
      seatCircle.set({
        fill: `${seatCircle.stroke}40`,
        radius: seatCircle.radius - 0.5,
      });
      this.canvasHandler.canvas.requestRenderAll();
      this.targetSeat = null;
    }
    else {
      this.canvasHandler.tooltipHandler.hide();
      this.canvasHandler.canvas.setCursor("default");
    }
  };
}
export default Seat;
